import React, { useState } from 'react'

import { IconButton } from '@mui/material'
import { Download } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import { getAntifraudeImage } from 'services/apiKYP'
import LoadingComponent from "../../../LoadingComponent"

const DownloadButton = (props) => {
  const { fileName } = props
  const token = useSelector((state) => state.auth.access_token)
  const [isLoading, setIsLoading] = useState(false)

  const handleDownloadClick = () => {
    setIsLoading(true)
    getAntifraudeImage(token, fileName)
      .then((response) => {
        const url = URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = url
        link.target = "blank"
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const loadingComponentProps = {
    loadingText: 'Baixando imagem...',
    layoutOrientation: "horizontal",
    textColor: '#FFF',
    progressSize: 20,
    textMargin: '10px',
    textSize: '16px',
    progressColor: "#FFF",
    minHeight: 'auto',
    fontWeight: '700',
    width: 'auto',
  }

  return (
    <IconButton
      onClick={handleDownloadClick}
      style={{ color: 'white' }}
      title='Download'
      disabled={isLoading}
    >
      {
        isLoading ?
          <LoadingComponent {...loadingComponentProps} /> :
          <Download />
      }
    </IconButton>
  )
}

export default DownloadButton
